import React from 'react'

import clsx from 'clsx'

import classes from './Skeleton.module.scss'

/** @type {import("./types").default} */
const Skeleton = ({ variant = 'text', animation = 'pulse', height, width, className, ...other }) => {
  return (
    <span
      className={clsx(
        'Skeleton',
        classes.root,
        classes[variant],
        {
          [classes[`${animation}`]]: animation !== false,
          [classes.fitContent]: !width,
          [classes.heightAuto]: !height,
        },
        className
      )}
      {...other}
      style={{ width, height, ...other.style }}
    />
  )
}

export default Skeleton
